import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { setClerkRouter } from '@/lib/clerkNavigation'

/** Mount once inside <BrowserRouter>: Clerk's steps then change without a page load (21 Oct 2026). */
export function ClerkNavigationBridge() {
  const navigate = useNavigate()
  useEffect(() => {
    setClerkRouter((to, replace) => navigate(to, { replace }))
    return () => setClerkRouter(null)
  }, [navigate])
  return null
}
